import React from 'react'
import PropTypes from 'prop-types'
import { Card, Separator, Button } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useQueryParams } from '@fs/zion-router'
import ProjectInfo from './ProjectInfo'

const cardContentCss = css`
  padding: 16px;
`

export default function ProjectCard({
  id,
  title,
  place,
  estimatedImages,
  languages,
  actualImagesCaptured,
  loading,
  isOnlyCard,
  openButtonText,
  closedButtonText,
  children,
}) {
  const [isCardOpen, setIsCardOpen] = React.useState(false)

  const { query } = useQueryParams()
  const { projectId } = query

  React.useEffect(() => {
    if (projectId === id && !isOnlyCard) {
      scrollToCard(projectId)
    }
  }, [id, isOnlyCard, projectId])

  return (
    <>
      <Card id={id}>
        <div css={cardContentCss}>
          <ProjectInfo {...{ id, title, place, estimatedImages, languages, actualImagesCaptured, loading }} />
          <Separator size="nano" />
          {!isOnlyCard && (
            <Button onClick={() => setIsCardOpen((curr) => !curr)} emphasis="medium" data-testid="project-card-toggle">
              {isCardOpen ? openButtonText : closedButtonText}
            </Button>
          )}
          {(isCardOpen || isOnlyCard) && <Separator size="nano" />}
          {(isCardOpen || isOnlyCard) && children}
        </div>
      </Card>
      <Separator size="sm" />
    </>
  )
}

ProjectCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  place: PropTypes.string,
  estimatedImages: PropTypes.number,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  actualImagesCaptured: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  isOnlyCard: PropTypes.bool,
  openButtonText: PropTypes.string,
  closedButtonText: PropTypes.string,
  children: PropTypes.node,
}

function scrollToCard(id) {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
